import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpRequest } from "@angular/common/http";
import { ConfigurationService } from "../../services/configuration.service";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinessUnitBricksService {

  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService,) {
  }

  getAllBusinessUnitLastLevel() {
    return this.http.get(this.configurations.apiAddress + "/api/businessUnit/getBusinessUnitsLastLevel");
  }

  getAllBricksLeafLevel() {
    return this.http.get(this.configurations.apiAddress + "/api/bricks/getBricksLeafLevel");
  }

  getBrickShareDetails(linkId: number, salesBricks: boolean) {
    return this.http.get(this.configurations.apiAddress + '/api/businessUnit/brickShareDetails/' + linkId, { params: new HttpParams().set('salesBricks', salesBricks ? 'true' : 'false') });
  }

  addBusinessUnitBricks(businessUnitId: number, brickIds: number[], startDate: string, endDate: string, isCentre = false, isSalesBrick = false) {
    let myParams = new HttpParams()
      .set("businessUnitId", businessUnitId.toString())
      .set("brickIds", brickIds.join(','))
      .set('startDate', startDate || "")
      .set('endDate', endDate || "")
      .set('isCentre', isCentre ? "true" : "false")
    if (isSalesBrick)
      return this.http.get(this.configurations.apiAddress + "/api/businessUnit/addBusinessUnitSalesBricks", { params: myParams });
    else
      return this.http.get(this.configurations.apiAddress + "/api/businessUnit/addBusinessUnitBricks", { params: myParams });
  }

  getBusinessUnitBricksByBusinessUnitd(businessUnitId: number, isSalesBrick = false) {
    if (isSalesBrick)
      return this.http.get(this.configurations.apiAddress + "/api/businessUnit/getBusinessUnitSalesBricksByBusinessUnitd/" + businessUnitId);
    else
      return this.http.get(this.configurations.apiAddress + "/api/businessUnit/getBusinessUnitBricksByBusinessUnitd/" + businessUnitId);
  }

  updateBusinessUnitBrick(link: { id: number, startDate: string, endDate: string, isCentre?: boolean }, isSalesBrick = false) {
    return this.http.put(this.configurations.apiAddress + "/api/businessUnit/" + (isSalesBrick ? "updateBusinessUnitSalesBrick" : "updateBusinessUnitBrick"),
      { id: link.id, startDate: link.startDate, endDate: link.endDate || null, isCentre: link.isCentre });
  }

  getBricksLevel(isSalesBrick = false) {
    return this.http.get<number>(this.configurations.apiAddress + "/api/businessUnit/bricksLevel", { params: new HttpParams().set('salesBricks', isSalesBrick ? 'true' : 'false') });
  }

  /** Closes several open links of one business unit on one end date (all or none). */
  closeBusinessUnitBricks(ids: number[], endDate: string, isSalesBrick = false) {
    const route = isSalesBrick ? "closeBusinessUnitSalesBricks" : "closeBusinessUnitBricks";
    return this.http.post<number>(this.configurations.apiAddress + "/api/businessUnit/" + route, { ids: ids, endDate: endDate });
  }

  deleteBusinessUnitBrickById(id: number, endDate: string, isSalesBrick = false) {
    let myParams = new HttpParams()
      .set('endDate', endDate || "");
    if (isSalesBrick)
      return this.http.delete(this.configurations.apiAddress + "/api/businessUnit/deleteBusinessUnitSalesBrickById/" + id, { params: myParams });
    else
      return this.http.delete(this.configurations.apiAddress + "/api/businessUnit/deleteBusinessUnitBrickById/" + id, { params: myParams });
  }

  downloadCsvTemplate(isSalesBrick = false): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/businessUnit/downloadCSVTemplateBUB", { responseType: "blob", params: new HttpParams().set('salesBricks', isSalesBrick ? 'true' : 'false') });
  }

  provisionBusinessUnitsBrick(formData, isSalesBrick = false) {
    if (isSalesBrick) {
      const uploadReq = new HttpRequest("POST", this.configurations.apiAddress + `/api/businessUnit/uploadCSVTemplateBUSalesBricks`, formData, {
        reportProgress: true,
      });
      return this.http.request(uploadReq);
    }
    else {
      const uploadReq = new HttpRequest("POST", this.configurations.apiAddress + `/api/businessUnit/UploadCSVTemplateBUB`, formData, {
        reportProgress: true,
      });
      return this.http.request(uploadReq);
    }

  }

  // The upload returns { jobId } at once and is processed in the background: poll this for progress + the summary.
  getProvisionStatus(jobId: string) {
    return this.http.get(this.configurations.apiAddress + "/api/businessUnit/provisionStatus/" + jobId);
  }

  // Per-row sheet of the rows that were skipped (already there) or rejected (not saved).
  downloadProvisionResultSheet(jobId: string): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/businessUnit/provisionResultSheet/" + jobId, { responseType: "blob" });
  }


  //addBusinessUnitSalesBricks(businessUnitId: number, brickIds: number[], startDate = undefined) {
  //  let myParams = new HttpParams()
  //    .set("businessUnitId", businessUnitId.toString())
  //    .set("brickIds", brickIds.join(', '))
  //    .set('startDate', startDate == undefined ? "" : startDate.toDateString())
  //  return this.http.get(this.configurations.apiAddress + "/api/businessUnit/addBusinessUnitSalesBricks", { params: myParams });
  //}

  //getBusinessUnitBricksSalesByBusinessUnitd(businessUnitId: number) {
  //  return this.http.get(this.configurations.apiAddress + "/api/businessUnit/getBusinessUnitSalesBricksByBusinessUnitd/" + businessUnitId);
  //}

  //deleteBusinessUnitSalesBrickById(id: number, endDate = undefined) {
  //  let myParams = new HttpParams()
  //    .set('endDate', endDate == undefined ? "" : endDate.toDateString());
  //  return this.http.delete(this.configurations.apiAddress + "/api/businessUnit/deleteBusinessUnitSalesBrickById/" + id, { params: myParams });
  //}

  //provisionBusinessUnitsSalesBrick(formData) {
  //  const uploadReq = new HttpRequest("POST", this.configurations.apiAddress + `/api/businessUnit/uploadCSVTemplateBUSalesBricks`, formData, {
  //    reportProgress: true,
  //  });
  //  return this.http.request(uploadReq);

  //}
}
